import { Global as EmotionGlobal, css } from '@emotion/react';

import { theme } from '../theme';

const overrideStyles = `
  .sas-datepicker-portal {
    .datepicker-popover {
      position: none;
      transform: none;
    }

    .react-datepicker {
      font-family: var(--sas-font-family);
      outline: none;
      border: none;
      box-shadow: var(--shadow-normal);
      width: 100%;
      padding: ${theme.spacing.lg};
      border-radius: ${theme.borders.radius.md};
    }

    .react-datepicker__input-container {
      input {
        width: 100%;
        height: 64px;
        padding: var(--margin-double) var(--margin-double) 0;
      }
    }

    .react-datepicker__header {
      background-color: var(--color-white);
      border: none;
      padding: 0;
    }

    .react-datepicker__month-container {
      background-color: var(--color-white);
      border-radius: 0;
      width: 100%
    }

    .react-datepicker__month {
      margin: ${theme.spacing.xs} 0;
    }

    .react-datepicker__day--keyboard-selected {
      background-color: transparent;
      color: inherit;

      &.react-datepicker__day--disabled {
        color: var(--color-gray-2);
      }
    }

    .react-datepicker__week, .react-datepicker__day-names {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
    }

    .react-datepicker__day-names {
      margin-bottom: ${theme.spacing.sm};
    }

    .react-datepicker__day-name {
      height: 24px;
      line-height: 24px;
      color: ${theme.colors.gray[2]};
      width: 100%;
      margin: 0;
    }

    .react-datepicker__day {
      width: 100%;
      height: 56px;
      font-size: 14px;
      line-height: 1.2;
      border-radius: 0;
      margin: 0 0 4px;
      position: relative;
      color: ${theme.colors.gray[4]};
      display: flex;
      align-items: center;
      justify-content: center;

      @media(max-width: ${theme.breakpoints.tablet}) {
        height: 44px;

        & > div > div {
          font-size: 10px;
        }
      }

      &--disabled {
        pointer-events: none;
        color: var(--color-gray-2);
      }

      &:not:selected:hover {
        background-color: var(--g0-color);
      }
    }

    .react-datepicker__day--highlighted {
      background: transparent;

      .react-datepicker__day-info {
        font-weight: ${theme.fontWeight.bold};
        color: #2F604B;
      }
    }

    .react-datepicker__day--selected-emphasized {
      .react-datepicker__day-info {
        color: var(--color-white);
      }
    }

    .react-datepicker__day--highlighted:not(.react-datepicker__day--selected) {
      &:hover {
        background-color: transparent;
      }

      .react-datepicker__highlighted-box {
        width: 100%;
        height: 100%;
        border-radius: ${theme.borders.radius.md};
        background-color: #D6EBE2;
        margin: 0 2px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        &:hover {
          background-color: #B4DAC9;
        }
      }
    }

    .react-datepicker__day--selected {
      background-color: var(--color-blue-1);
      color: var(--color-black);

      &:hover {
        background-color: var(--color-blue-1-2);
      }

      &:focus-visible {
        outline-color: transparent;
        outline: 1px solid var(--color-gray-3);
      }

      &.react-datepicker__day--disabled {
        pointer-events: none;
        color: var(--color-gray-2);
      }
    }

    .react-datepicker__day--selected-emphasized {
      background-color: var(--color-blue-2);
      color: var(--color-white);

      border-radius: ${theme.borders.radius.md};

      & > div > span {
        background-color: var(--color-gray-2);
      }

      &:focus-visible {
        outline-color: transparent;
        outline: 1px solid var(--color-gray-3);
      }

      &:hover {
        background-color: var(--color-blue-2);
        color: var(--color-white);
      }
    }

    .react-datepicker__day--selected {
      border-radius: 0;
    }

    .react-datepicker__day--selected-start {
      border-top-left-radius: ${theme.borders.radius.md};
      border-bottom-left-radius: ${theme.borders.radius.md};
    }

    .react-datepicker__day--selected-end {
      border-top-right-radius: ${theme.borders.radius.md};
      border-bottom-right-radius: ${theme.borders.radius.md};
    }

    .react-datepicker__day--outside-month {
      visibility: hidden;
    }

    .sas-icon-cl--close {
      color: var(--color-gray-5);
    }

    .react-datepicker__arrow-button {
      outline: none;
      border: ${theme.colors.primary};
      background: ${theme.colors.primary};
      margin: 0;
      padding: 6px;
      min-height: auto;
      min-width: auto;
      border: 1px solid transparent;
      border-radius: 0px;
      border-radius: 50%;
      height: ${theme.spacing.xxl};
      width: ${theme.spacing.xxl};

      > svg {
        height: ${theme.fontSize.lg};
        width: ${theme.fontSize.lg};
        color: ${theme.colors.white};
        cursor: pointer;
      }

      &:active,
      &:focus,
      &:focus-visible {
        outline: none;
        box-shadow: none;
        border: 1px solid var(--color-gray-3);

        > svg {
          color: var(--color-gray-2);
        }
      }

      &.disabled {
        background-color: var(--color-gray-2);
        cursor: unset;

        &:active,
        &:focus,
        &:focus-visible {
          border: 1px solid transparent;
        }

        > svg {
          cursor: unset;
          color: ${theme.colors.white};
        }
      }
    }

    .sas-datepicker__date-input {
      all: unset;
      font-size: 16px;
      padding: 4px 0;
      color: var(--color-gray-5);

      &:focus {
        outline: none;
      }
    }

    .sas-datepicker__date-input::-webkit-clear-button,
    .sas-datepicker__date-input::-ms-clear {
      display: none;
    }

    .sas-datepicker__date-input::-webkit-inner-spin-button,
    .sas-datepicker__date-input::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }

    .react-datepicker__day:focus-visible,
    .react-datepicker__day--selected-emphasized:focus-visible,
    .react-datepicker__day--highlighted:focus-visible,
    .react-datepicker__day--selected:focus-visible {
      border: 1px solid var(--color-gray-3);
      outline: none;
      font-weight: 700;
    }
  }
`;

export function DatepickerStylesOverride() {
  return <EmotionGlobal styles={css(overrideStyles)} />;
}
